import request from '@/utils/request';

//获取省市
export function regionlist(pid) {
  return request({
    url: '/wx/region/list',
    method: 'get',
    params: { pid }
  })
}


// WEBPACK FOOTER //
// ./src/api/region/region.js